import { render, staticRenderFns } from "./HeaderCompact.vue?vue&type=template&id=54a587a9&"
import script from "./HeaderCompact.vue?vue&type=script&lang=ts&"
export * from "./HeaderCompact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports